import { clientResumes } from "../actions/types"

const defaultTemplatesData = {
	data: [],
	isLoading: true,
	isShowing: true,
	hasError: false,
	per_page: 15,
	current_page: 1,
	filters: [],
	isLoadingActions:false,
	meta: {
		pagination: {
			total: 0,
			count: 0,
			per_page: 15,
			current_page: 1,
			total_pages: 1,
		}
	}
}


const clientResumesReducer = (state = defaultTemplatesData, action) => {
	switch (action.type) {
		case clientResumes.GET_CLIENT_RESUMES_STARTED:
			return { ...state, isLoading: true }

		case clientResumes.GET_CLIENT_RESUMES_SUCCESS:
			return { ...state, ...action.payload, isLoading: false }

		case clientResumes.GET_CLIENT_RESUMES_ERROR:
			return { ...state, isLoading: false }

		case clientResumes.CREATE_CLIENT_RESUMES_STARTED:
			return { ...state, isLoading: true }

		case clientResumes.CREATE_CLIENT_RESUMES_SUCCESS:
			return { ...state, ...action.payload, isLoading: false }

		case clientResumes.CREATE_CLIENT_RESUMES_ERROR:
			return { ...state, isLoading: false }

		case clientResumes.DELETE_CLIENT_RESUMES_STARTED:
			return { ...state, isLoading: true }

		case clientResumes.DELETE_CLIENT_RESUMES_SUCCESS:
			if (action.payload)
				return { ...state, data: state.data.filter(item => (item.id !== action.payload.id)), isLoading: false }
			return state

		case clientResumes.DELETE_CLIENT_RESUMES_ERROR:
			return { ...state, isLoading: false }
		default:
			return state
	}
}

export default clientResumesReducer
